export default "__VITE_ASSET__BEOmVh9___"